module.exports = __webpack_public_path__ + "front/img/btn_2.9da3f63f.jpg";